/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { StaffRequestRecipient } from './StaffRequestRecipient';
import {
    StaffRequestRecipientFromJSON,
    StaffRequestRecipientFromJSONTyped,
    StaffRequestRecipientToJSON,
    StaffRequestRecipientToJSONTyped,
} from './StaffRequestRecipient';
import type { ReminderSettings } from './ReminderSettings';
import {
    ReminderSettingsFromJSON,
    ReminderSettingsFromJSONTyped,
    ReminderSettingsToJSON,
    ReminderSettingsToJSONTyped,
} from './ReminderSettings';
import type { StaffRequestItem } from './StaffRequestItem';
import {
    StaffRequestItemFromJSON,
    StaffRequestItemFromJSONTyped,
    StaffRequestItemToJSON,
    StaffRequestItemToJSONTyped,
} from './StaffRequestItem';
import type { RequestStatus } from './RequestStatus';
import {
    RequestStatusFromJSON,
    RequestStatusFromJSONTyped,
    RequestStatusToJSON,
    RequestStatusToJSONTyped,
} from './RequestStatus';

/**
 * 
 * @export
 * @interface StaffRequest
 */
export interface StaffRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    case_id: string;
    /**
     * 
     */
    title: string;
    /**
     * 
     */
    message: string | null;
    /**
     * 
     */
    status: RequestStatus;
    /**
     * 
     */
    due_at: Date | null;
    /**
     * 
     */
    revision: number;
    /**
     * 
     */
    sent_at: Date | null;
    /**
     * 
     */
    created_at: Date;
    /**
     * 
     */
    items: Array<StaffRequestItem>;
    /**
     * 
     */
    recipients: Array<StaffRequestRecipient>;
    /**
     * 
     */
    reminder_settings: ReminderSettings;
}



/**
 * Check if a given object implements the StaffRequest interface.
 */
export function instanceOfStaffRequest(value: object): value is StaffRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('case_id' in value) || value['case_id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('due_at' in value) || value['due_at'] === undefined) return false;
    if (!('revision' in value) || value['revision'] === undefined) return false;
    if (!('sent_at' in value) || value['sent_at'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('recipients' in value) || value['recipients'] === undefined) return false;
    if (!('reminder_settings' in value) || value['reminder_settings'] === undefined) return false;
    return true;
}

export function StaffRequestFromJSON(json: any): StaffRequest {
    return StaffRequestFromJSONTyped(json, false);
}

export function StaffRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'case_id': json['case_id'],
        'title': json['title'],
        'message': json['message'],
        'status': RequestStatusFromJSON(json['status']),
        'due_at': (json['due_at'] == null ? null : parseDateTime(json['due_at'])),
        'revision': json['revision'],
        'sent_at': (json['sent_at'] == null ? null : parseDateTime(json['sent_at'])),
        'created_at': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
        'items': ((json['items'] as Array<any>).map(StaffRequestItemFromJSON)),
        'recipients': ((json['recipients'] as Array<any>).map(StaffRequestRecipientFromJSON)),
        'reminder_settings': ReminderSettingsFromJSON(json['reminder_settings']),
    };
}

export function StaffRequestToJSON(json: any): StaffRequest {
    return StaffRequestToJSONTyped(json, false);
}

export function StaffRequestToJSONTyped(value?: StaffRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'case_id': value['case_id'],
        'title': value['title'],
        'message': value['message'],
        'status': RequestStatusToJSON(value['status']),
        'due_at': value['due_at'] == null ? value['due_at'] : serializeDateTime(value['due_at']),
        'revision': value['revision'],
        'sent_at': value['sent_at'] == null ? value['sent_at'] : serializeDateTime(value['sent_at']),
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
        'items': ((value['items'] as Array<any>).map(StaffRequestItemToJSON)),
        'recipients': ((value['recipients'] as Array<any>).map(StaffRequestRecipientToJSON)),
        'reminder_settings': ReminderSettingsToJSON(value['reminder_settings']),
    };
}

